/**
 * Created by chenli
 */
import Component from "../../../../../../lib/component";
import template from './expert-search-condition-adQuery.html';
import './expert-search-condition-adQuery.scss';
import DateTimeControl from "../../../../../form/datetime-control/datetime-control";
import DateControl from "../../../grid-data-control/grid-data-control";
import {AutoSelect} from '../../../../../util/autoSelect/autoSelect';
import TimeControl from "../../../../../form/time-control/time-control";

let expertConditionAdQuery = Component.extend({
    template: template,
    data: {
        isAdd: false
    },
    actions: {
    /**
     * 渲染单选，多选类型
     * @param content
     * @param isMult
     */
    setSelectControlValue(content,isMult){
            for(let i in content) {
                let liBtnName = content[i]['name']
                let oneBtn = document.createElement('button');
                oneBtn.className = 'my-light-blue-btn';
                if(isMult) {
                    $(oneBtn).on('click',(e)=> {
                        if(!$(oneBtn).hasClass('my-light-btn-click')){
                            $(oneBtn).addClass('my-light-btn-click');
                        }else{
                            $(oneBtn).removeClass('my-light-btn-click');
                        }
                    })
                }else {
                    $(oneBtn).on('click',(e)=> {
                        $(oneBtn).addClass('my-light-btn-click');
                        $(oneBtn).siblings().removeClass('my-light-btn-click');
                    })
                }
                oneBtn.value = liBtnName;
                oneBtn.innerHTML = liBtnName;
                this.el.find('.condition-search-value').append(oneBtn)
            }
        },
        //多选
        // setMultiSelectControlValue(content,multChoosed){
        //     let selectData = {
        //         list: content,
        //         choosed: multChoosed || [],
        //         multiSelect: true,
        //         width:'172px',
        //         onSelect:function(choosed) {
        //             if(choosed.length != 0){
        //
        //             }
        //         }
        //     }
        //     this.append(new AutoSelect({data:selectData}),this.el.find('.condition-search-value'))
        // },
        /*
        * 限制字符串长度，超过用...代替
        * text:string，
        * len:最大显示的字符串长度
        */
        hideText:function(text,len){
            let name;
            if (text.length>len){
                 name = text.substring(0,len)+'...';
            }
            return name
        },
        //设置搜索值框的类型
        setInputType: function(selectValue) {
            selectValue.forEach((item)=>{
                let typeName = this.el.find('.type-name');
                let radio = this.data.isAdd ? '$or' : '$and';
                if (item.name.length>5){
                    item.title=item.name;
                    typeName.attr('title',item.name)
                    item.name=this.actions.hideText(item.name,5)
                }
                typeName.html(item.name);
                typeName.attr({
                    type:item.type,
                    name:item.title||item.name,
                    id:item.id,
                    radio:radio
                });
                switch (item.type) {
                    case "datetime":
                        let dateTimeControl1 = new DateTimeControl({data:{value: '', isAgGrid: true},events:{changeValue:function(data){}}});
                        let dateTimeControl2 = new DateTimeControl({data:{value: '', isAgGrid: true},events:{changeValue:function(data){}}});
                        this.el.find('.condition-search-value').append('<span class="tips-begin">从</span>');
                        this.append(dateTimeControl1,this.el.find('.condition-search-value'));
                        this.el.find('.condition-search-value').append('<span  class="tips-end">起</span><br/><br/>');
                        this.el.find('.condition-search-value').append('<span  class="tips-begin">到</span>');
                        this.append(dateTimeControl2,this.el.find('.condition-search-value'));
                        this.el.find('.condition-search-value').append('<span class="tips-end">止</span>');
                        this.el.find('.condition-search-value div').css('display','inline-block');
                        break;
                    case "date":
                        let dateControl = new DateControl({data:{value: '', isAgGrid: true},events:{changeValue:function(data){}}});
                        this.el.find('.condition-search-value').append('<span  class="tips-begin">从</span>');
                        this.append(dateControl,this.el.find('.condition-search-value'));
                        this.el.find('.condition-search-value').append('<span class="tips-end">起</span><br/><br/>');
                        this.el.find('.condition-search-value').append('<span  class="tips-begin">到</span>');
                        this.append(dateControl,this.el.find('.condition-search-value'));
                        this.el.find('.condition-search-value').append('<span class="tips-end">止</span>');
                        this.el.find('.condition-search-value div').css('display','inline-block');
                        break;
                    case "time":
                        let timeControl1 = new TimeControl({data:{value: '', isAgGrid: true},events:{changeValue:function(data){}}});
                        let timeControl2 = new TimeControl({data:{value: '', isAgGrid: true},events:{changeValue:function(data){}}});
                        this.el.find('.condition-search-value').append('<span class="tips-begin">从</span>');
                        this.append(timeControl1,this.el.find('.condition-search-value'));
                        this.el.find('.condition-search-value').append('<span  class="tips-end">起</span><br/><br/>');
                        this.el.find('.condition-search-value').append('<span  class="tips-begin">到</span>');
                        this.append(timeControl2,this.el.find('.condition-search-value'));
                        this.el.find('.condition-search-value').append('<span class="tips-end">止</span>');
                        let component = this.el.find(`.condition-search-value div[component]`);
                        $(component[0]).css('display','inline-block');
                        $(component[1]).css('display','inline-block');
                        break;
                    case "year":
                        this.el.find('.condition-search-value').append('<span class="tips-begin">从</span>');
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input" type="text" style="width:230px">`);
                        this.el.find('.condition-search-value').append('<span  class="tips-end">起</span><br/><br/>');
                        this.el.find('.condition-search-value').append('<span  class="tips-begin">到</span>');
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input" type="text" style="width:230px">`);
                        this.el.find('.condition-search-value').append('<span class="tips-end">止</span>');
                        this.el.find('.condition-search-value .tips-end').css('margin-left','15px');
                        break;
                    case "year-month":
                        this.el.find('.condition-search-value').append('<span class="tips-begin">从</span>');
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input" type="text" style="width:230px">`);
                        this.el.find('.condition-search-value').append('<span  class="tips-end">起</span><br/><br/>');
                        this.el.find('.condition-search-value').append('<span  class="tips-begin">到</span>');
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input" type="text" style="width:230px">`);
                        this.el.find('.condition-search-value').append('<span class="tips-end">止</span>');
                        this.el.find('.condition-search-value .tips-end').css('margin-left','15px');
                        break;
                    case "text":
                        this.el.find('.condition-search-select').css('display','inline-block');
                        this.el.find('.condition-search-value').css('margin-top','-20px');
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input" type="text">`);
                        this.el.find('.condition-search-value .tips-end').css('margin-left','0');
                        break;
                    case "number":
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input number-input" type="number">`);
                        this.el.find('.condition-search-value').append('<span><span class="less-than">≤</span><span class="number-name"></span><span class="less-than">≤</span></span>');
                        this.el.find('.condition-search-value').append(`<input class="condition-search-input number-input" type="number">`);
                        item.title? this.el.find('.number-name').html(item.title): this.el.find('.number-name').html(item.name);
                        break;
                    case "select":
                        this.el.find('.condition-search-value').css('width','500px');
                        this.actions.setSelectControlValue(item.fieldContent,false);
                        break;
                    case "single-select":
                        this.el.find('.condition-search-value').css('width','500px');
                        this.actions.setSelectControlValue(item.fieldContent,false);
                        break;
                    case "multi-select":
                        this.el.find('.condition-search-value').css('width','500px');
                        this.actions.setSelectControlValue(item.fieldContent,true);
                        break;
                }
            })
        },
    },
    afterRender: function() {
        let selectItem = this.data.expertItemData;
        this.actions.setInputType(selectItem);
    }
})
export default expertConditionAdQuery


// WEBPACK FOOTER //
// app/components/dataGrid/data-table-toolbar/expert-search/expert-search-condition-simple/expert-search-condition-adQuery/expert-search-condition-adQuery.js